import { Box, Circle, Image, Text, CircularProgress, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { formatLiveCourseDateTime } from "../../redux/actions/action";
// import { upcoming_live_classes } from "../../data";

export default function UpcomingClasses() {
    const { liveCoursesData, isLoading } = useSelector(state => state.liveCoursesState)
    const [visibleData, setVisibleData] = useState([])
    const history = useHistory()

    useEffect(() => {
        if (!isLoading && liveCoursesData.length) {
            setVisibleData(liveCoursesData.slice(0, 3))
        }
    }, [liveCoursesData, isLoading])

    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1rem'
            flex='1'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                UPCOMING LIVE CLASSES
            </Text>

            <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                px='2rem'
                pt='0.5rem'
            >
                {
                    isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                        <CircularProgress isIndeterminate color='#3e59de' size='50px' mt='2' />
                    </Box> :
                        visibleData.length > 0 ?
                            visibleData.map((session, idx) => <Box
                                w='100%'
                                d='flex'
                                alignItems='center'
                                py='0.5rem'
                                borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                                justifyContent='space-between'
                                key={idx}
                            >
                                <Box
                                    d='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                >
                                    <Circle
                                        bg='#FE58581A'
                                        size='35px'
                                        mr='1rem'
                                    >
                                        <Image
                                            src={session.cover_image_url ? session.cover_image_url : './images/unavailable-image.jpg'}
                                            // alt='LC' 
                                            // fallbackSrc={"https://source.unsplash.com/random/400x300"} 
                                            objectFit='cover'
                                            width='100%'
                                            height='100%'
                                            borderRadius='50%'
                                        />
                                    </Circle>

                                    <Tooltip
                                        label={session.title}
                                        fontSize='16px'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        fontWeight='400'
                                        color='#ffffff'
                                        bg='#333333'
                                        hasArrow
                                    >
                                        <Text
                                            fontWeight='600'
                                            color='#222222'
                                            fontSize='14px'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            textTransform='capitalize'
                                            width='28ch'
                                            textAlign='start'
                                            whiteSpace='nowrap'
                                            overflow='hidden'
                                            textOverflow='ellipsis'
                                        >
                                            {session.title}
                                        </Text>
                                    </Tooltip>
                                </Box>
                                <Box
                                    fontWeight='400'
                                    color='#00000080'
                                    fontSize='10px'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                >
                                    <Text >
                                        {formatLiveCourseDateTime(session.start).split('at')[0]}
                                    </Text>
                                    <Text>
                                        {formatLiveCourseDateTime(session.start).split('at')[1]}
                                    </Text>
                                </Box>
                            </Box>)
                            :
                            <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='2rem'>
                                <Text
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                    fontWeight="400"
                                    fontSize={["12px", "14px", "16px", "18px"]}
                                >
                                    Nothing to display!
                                </Text>
                            </Box>
                }
                <Box
                    w='100%'
                    d='flex'
                    justifyContent='center'
                    alignItems='center'
                    py='1rem'
                >
                    <Text
                        fontWeight='800'
                        color='#FD337B'
                        fontSize='10px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        textTransform='uppercase'
                        onClick={() => history.push('/live-sessions')}
                        cursor='pointer'
                    >
                        View More
                    </Text>
                </Box>

            </Box>

        </Box>

    )
}